import React from "react";
import { useLocation } from "react-router-dom";
import TOCModuleSubtopic from "../TOCModuleSubtopic";

const ModuleSummaryTOC = () => {
  const location = useLocation();
  const { subtopics, subjectPath } = location.state || { subtopics: [], subjectPath: '' };

  return (
    <TOCModuleSubtopic
      subtopics={subtopics}
      subjectPath={subjectPath}
      title="Module Summary: Proof Techniques and Basics of TOC"
      videos={[]} // No specific videos for the summary
      takeaways={[
        { text: "This module has only two main topics: proof techniques and the basics of TOC." },
        { text: "Mainly, focus on learning the definitions of all the concepts mentioned in this module." },
        { text: "Learn the properties of different operations and how to perform various operations on the grammar." },
      ]}
      questions={[]}
      exampleVideos={[]} // Add example question videos if needed
    />
  );
}

export { ModuleSummaryTOC };